import fetchServer from "../helpers/api/fetchServer";

export const createInterestGroup = async ({ name, adPlatformId }) => {
  const method = "POST";
  const urlAPI = "/api/interestGroups";
  const body = {
    name,
    adPlatformId,
  };
  return await fetchServer({ method, urlAPI, body });
};

export const getInterestGroups = async () => {
  const method = "GET";
  const urlAPI = "/api/interestGroups";
  return await fetchServer({ method, urlAPI });
};

export const getInterestGroupsByAdPlatform = async (adPlatformId) => {
  const method = "GET";
  const urlAPI = `/api/interestGroups?adPlatform=${adPlatformId}`;
  return await fetchServer({ method, urlAPI });
};

export const getInterestGroup = async (id) => {
  const method = "GET";
  const urlAPI = `/api/interestGroups/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const updateInterestGroup = async ({ id, name, adPlatformId }) => {
  const method = "PATCH";
  const urlAPI = `/api/interestGroups/${id}`;
  const body = { name, adPlatformId };
  return await fetchServer({ method, urlAPI, body });
};

export const updateInterestGroupInterests = async ({ id, interestIds }) => {
  const method = "PATCH";
  const urlAPI = `/api/interestGroups/${id}/interests`;
  const body = { interestIds };
  return await fetchServer({ method, urlAPI, body });
};

export const deleteInterestGroup = async (id) => {
  const method = "DELETE";
  const urlAPI = `/api/interestGroups/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const restoreInterestGroup = async (id) => {
  const method = "POST";
  const urlAPI = `/api/interestGroups/${id}/restore`;
  return await fetchServer({ method, urlAPI });
};

export const deleteInterestGroups = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/interestGroups/bulk-delete";
  const body = {ids};
  return await fetchServer({ method, urlAPI, body });
};

export const restoreInterestGroups = async (ids) => {
  const method = "POST";
  const urlAPI = "/api/interestGroups/bulk-restore";
  const body = {ids};
  return await fetchServer({ method, urlAPI, body });
};
